import { baseUrl } from "./httpService";

let talukaUrls = null;
let talukaDataCache = null;

export const fetchTalukaUrls = async () => {
  if (talukaUrls && talukaDataCache) return { urls: talukaUrls, data: talukaDataCache };
  try {
    const res = await fetch(`${baseUrl}taluka`);
    const json = await res.json();
    if (json.status) {
      const urls = new Set();
      const patchedData = json.data.map(city => {
        // District hub gets -taluka-news to avoid collision with city pages
        const patchedCityUrl = city.url ? `${city.url}` : null;
        if (patchedCityUrl) urls.add(patchedCityUrl.toLowerCase());

        // Talukas use their dynamic URL from the API
        const patchedTalukas = (city.talukas || []).map(t => {
          const talukaUrl = t.url;
          if (talukaUrl) urls.add(talukaUrl.toLowerCase());
          return { ...t, url: talukaUrl };
        });

        return { ...city, url: patchedCityUrl, talukas: patchedTalukas };
      });

      talukaUrls = urls;
      talukaDataCache = patchedData;
      return { urls, data: patchedData };
    }
  } catch (e) {
    console.error("Failed to fetch taluka URLs:", e);
  }

  talukaUrls = new Set();
  talukaDataCache = [];
  return { urls: talukaUrls, data: talukaDataCache };
};

export const getTalukaUrlsSync = () => talukaUrls;
export const getTalukaDataSync = () => talukaDataCache;
